module.exports = __webpack_public_path__ + "media/images/icons/filled/gift-bed5f242a94165c264049cc2b40cb889.svg";